import getActionsByDocument from '../../../../../../components/logs/actions';

const DOCUMENT = 'POSITION_LOGS_';

export default getActionsByDocument(DOCUMENT);
